document.addEventListener('DOMContentLoaded', function () {
  const content = document.querySelector('.listicle-content');
  const toc = document.querySelector('.listicle-toc');
  const tocList = document.querySelector('.listicle-toc ol');
  if (!content || !tocList || !toc) return;

  const headings = content.querySelectorAll('h2, h3');
  let itemNumber = 1;

  headings.forEach(function (heading) {
    const slug = heading.textContent.trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/(^-|-$)/g, '');
    heading.id = slug;

    const anchor = document.createElement('a');
    anchor.href = '#' + slug;
    anchor.className = 'heading-anchor';
    anchor.innerHTML = '#';
    heading.appendChild(anchor);

    if (heading.tagName === 'H2') {
      const li = document.createElement('li');
      const link = document.createElement('a');
      link.href = '#' + slug;
      link.textContent = itemNumber + '. ' + heading.textContent.replace('#', '').trim();
      li.appendChild(link);
      tocList.appendChild(li);
      itemNumber++;
    }
  });

  // Toon TOC alleen als er H2 items zijn
  if (tocList.children.length > 0) {
    toc.classList.add('is-visible');
  }
});

